<template>
  <div class="flex h-screen w-full overflow-x-hidden overflow-y-auto">
    <div class="flex-1 flex flex-col w-full overflow-x-hidden">
      <router-view v-slot="slotProps">
        <component :is="slotProps.Component"></component>
      </router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>
